export default [
    {
        path: '/employee-discount/my',
        name: 'my_employee_discount',
        component: () => import('@src/employee-discount/my-employee-discount'),
        meta: {
            title: 'Mein Geldwerter Vorteil',
            role: 'ROLE_SHOW_CUSTOMER_GROUP_MY_EMPLOYEE_DISCOUNT',
        },
    },
    {
        path: '/employee-discount/customer',
        name: 'employee_discount_customer',
        component: () => import('@src/employee-discount/employee-discount'),
        meta: {
            title: 'Auswertung Mitarbeiter',
            role: 'ROLE_SHOW_CUSTOMER_GROUP_EMPLOYEE_DISCOUNT',
        },
    },
    {
        path: '/employee-deactivated',
        name: 'employee_deactivated',
        component: () => import('@src/employee-discount/list-employee-deactivated.vue'),
        meta: {
            title: 'Deaktivierte Mitarbeiter',
            role: 'ROLE_LIST_EMPLOYEE',
        },
    },
];
